export default function getCategoryName (categoryName: string) :string {
  const removeSlash = categoryName.split('/');
  return removeSlash[removeSlash.length -1];
}